import styles from './index.module.scss';

const LoadingPage = () => (
  <div className={styles.base}>
    <h1 className={styles.title}>みらいキッズモンテプリスクール</h1>
    <p className={styles['loading-text']}>読み込み中...</p>
  </div>
);

export default LoadingPage;
